import * as React from "react";
import type { SVGProps } from "react";
const SvgResourceIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="resource_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M715.093 128H308.907a128.085 128.085 0 0 0-114.56 70.997v.043L47.573 492.16A42.496 42.496 0 0 0 42.667 512v256a128 128 0 0 0 128 128h682.666a128 128 0 0 0 128-128V510.379a42.496 42.496 0 0 0-4.906-18.262L829.653 199.04v-.043A128 128 0 0 0 715.093 128zm154.454 341.333h-186.88a42.667 42.667 0 0 0-35.499 18.987l-72.661 109.013H449.493L376.832 488.32a42.667 42.667 0 0 0-35.499-18.987h-186.88l116.224-232.192L256 234.667l14.763 2.346a42.667 42.667 0 0 1 38.144-23.68h406.186a42.667 42.667 0 0 1 38.144 23.68l.086.128 116.224 232.192zM128 554.667h190.507l72.661 109.013a42.667 42.667 0 0 0 35.499 18.987h170.666a42.667 42.667 0 0 0 35.499-18.987l72.661-109.013H896V768a42.667 42.667 0 0 1-42.667 42.667H170.667A42.667 42.667 0 0 1 128 768V554.667z"
    />
  </svg>
);
export default SvgResourceIcon;
